"use strict";

var _slicedToArray = require("/builds/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var preact_1 = require("preact");

var hooks_1 = require("preact/hooks");

var notification_action_1 = require("../actions/notification.action");

var Message_1 = __importDefault(require("../atomic/Message"));

var Profile_1 = __importDefault(require("../atomic/Profile"));

var StationName_1 = __importDefault(require("../atomic/StationName"));

var helpers_1 = require("../helpers");

var useDebounceCallback_1 = __importDefault(require("../hooks/useDebounceCallback"));

var config_1 = require("../constants/config");

var notification_action_2 = require("../actions/notification.action");

var notice_action_1 = require("../actions/notice.action");

var Login_1 = __importDefault(require("../components/Login"));

var useInfiniteScroll_1 = require("../hooks/useInfiniteScroll");

function NotificationList(props) {
  var _ref = (0, hooks_1.useState)([]),
      _ref2 = _slicedToArray(_ref, 2),
      items = _ref2[0],
      setItems = _ref2[1];

  var _ref3 = (0, hooks_1.useState)(true),
      _ref4 = _slicedToArray(_ref3, 2),
      loading = _ref4[0],
      setLoading = _ref4[1];

  var _ref5 = (0, hooks_1.useState)(false),
      _ref6 = _slicedToArray(_ref5, 2),
      hasMore = _ref6[0],
      setHasMore = _ref6[1];

  var _ref7 = (0, hooks_1.useState)(0),
      _ref8 = _slicedToArray(_ref7, 2),
      lastSeq = _ref8[0],
      setLastSeq = _ref8[1];

  var _ref9 = (0, hooks_1.useState)(false),
      _ref10 = _slicedToArray(_ref9, 2),
      badge = _ref10[0],
      setBadge = _ref10[1];

  var _ref11 = (0, useInfiniteScroll_1.useInfiniteScroll)({
    delay: 100,
    onChange: function onChange(inView) {
      if (inView && loading === false && hasMore) {
        fetchList(lastSeq);
      }
    }
  }),
      lastPositionRef = _ref11.ref,
      inView = _ref11.inView;

  (0, hooks_1.useEffect)(function () {
    // 페이지 로드 시 뱃지 상태 업데이트
    fetchList();
    (0, notification_action_2.fetchBadge)().then(function (response) {
      setBadge(response.badge_flag ? true : false);
    });
  }, []);
  var fetchList = (0, hooks_1.useCallback)(function (seq) {
    setLoading(true);
    (0, notification_action_1.fetchNotifications)(seq).then(function (response) {
      setLoading(false);
      setItems(function (prevState) {
        return prevState.concat(response.data);
      });
      setHasMore(response.has_more === 1);
      setLastSeq(response.last_seq);
    }).catch(function () {
      setLoading(false);
    });
  }, []);
  var handleStepChange = (0, hooks_1.useCallback)(function (step) {
    return function (e) {
      e.stopPropagation();
      e.preventDefault(); // 안내 -> 알림 탭으로 넘어갈때 뱃지 데이터 갱신 badge가 new일때만 동작

      if (step === 'COMPONENT_LIST' && props.userId !== "" && badge) {
        (0, notification_action_2.fetchBadge)().then(function (response) {
          setBadge(response.badge_flag ? true : false);
        });
      }

      props.onStepChange(step);
    };
  }, []);
  var handleBtnGoSetting = (0, hooks_1.useCallback)(function () {
    return function (e) {
      window.open("".concat(config_1.NOTI_DOMAIN, "/setting "), '_blank');
    };
  }, []);
  /**
   * 전체읽음
   */

  var handleNotificationReadAll = (0, hooks_1.useCallback)(function (e) {
    e.preventDefault();
    var first_seq = items.length ? items[0].seq : 0;
    var actionType = "read_all";
    (0, notification_action_1.updateNotificationFlag)(actionType, first_seq).then(function () {
      setItems(function (prevState) {
        return prevState.map(function (value) {
          value.read_flag = "1";
          return value;
        });
      });
    });
    (0, helpers_1.setClickLogapi)("noti_00000001", {
      button_type: actionType
    });
  }, [items]);
  /**
   * 전체삭제
   */

  var handleNotificationDeleteAll = (0, hooks_1.useCallback)(function (e) {
    e.preventDefault();
    var first_seq = items.length ? items[0].seq : 0;
    var actionType = "delete_all";
    (0, notification_action_1.updateNotificationFlag)(actionType, first_seq).then(function () {
      setItems([]); //전체 아이템제거
    });
    (0, helpers_1.setClickLogapi)("noti_00000001", {
      button_type: actionType
    });
  }, [items]);
  /**
   * 읽은항목 삭제
   */

  var handleNotificationReadDelete = (0, hooks_1.useCallback)(function (e) {
    e.preventDefault();
    var first_seq = items.length ? items[0].seq : 0;
    var actionType = "delete_read";
    (0, notification_action_1.updateNotificationFlag)(actionType, first_seq).then(function () {
      setItems(function (prevState) {
        return prevState.filter(function (value) {
          return value.read_flag === "0";
        });
      });
    });
    (0, helpers_1.setClickLogapi)("noti_00000001", {
      button_type: actionType
    });
  }, [items]);
  /**
   * 알림 삭제하기
   */

  var handleNotificationDelete = (0, hooks_1.useCallback)(function (item) {
    return function (e) {
      e.preventDefault();
      (0, notification_action_1.destoryNotification)(item.seq).then(function () {
        setItems(function (prevState) {
          var index = prevState.findIndex(function (value) {
            return value.seq === item.seq;
          });
          prevState.splice(index, 1);
          return prevState.slice();
        });
      }).catch(function () {});
      var data = Object.assign({
        button_type: "landing"
      }, item.log_info);
      (0, helpers_1.setClickLogapi)("noti_00000001", data);
    };
  }, []);
  var handleNotificationRanding = (0, hooks_1.useCallback)(function (item) {
    return function (e) {
      if (!item.rending_url) {
        e.preventDefault();
      } //읽음처리


      setItems(function (prevState) {
        var index = prevState.findIndex(function (value) {
          return value.seq === item.seq;
        });
        prevState[index].read_flag = "1";
        return prevState.slice();
      });
      (0, notification_action_1.readNotification)(item.seq).finally(function () {
        /**
         * 클릭로그
         */
        var data = Object.assign({
          button_type: "landing"
        }, item.log_info);
        (0, helpers_1.setClickLogapi)("noti_00000001", data);
        var szBjId = item.from_id || "";
        var nCommonNo = item.log_info.common_no || 0;
        var paths = ["separate", "noti", (0, notification_action_1.getInflowPath)(item.noti_type)];

        if (["F01", "F21"].indexOf(item.noti_type) > -1) {
          //LIVE 유입로그
          (0, helpers_1.liveInflowLog)(szBjId, nCommonNo, paths);
        } else if (["F03", "A08", "B03", "B04", "B07", "A02", "A05", "A10", "A13"].indexOf(item.noti_type) > -1) {
          //VOD 유입로그
          (0, helpers_1.vodInflowLog)(szBjId, nCommonNo, paths);
        }
      });
    };
  }, []);
  var handleScroll = (0, useDebounceCallback_1.default)(function (scrollState) {
    var bottomPosition = scrollState.realHeight - scrollState.containerHeight;

    if (bottomPosition === scrollState.topPosition) {
      if (loading === false && hasMore) {
        fetchList(lastSeq);
      }
    }
  }, 300, [loading, hasMore, lastSeq]);
  /**
   * 휠클릭
   */

  var handleNotificationRandingWheelClick = (0, hooks_1.useCallback)(function (item) {
    return function (e) {
      if (e.button === 1) {
        handleNotificationRanding(item)(e);
      }
    };
  }, []);
  /**
   * 클래스
   */

  var getItemClass = (0, hooks_1.useCallback)(function (item) {
    if (!item) {
      return '';
    }

    var classNames = "";

    if (item.thumbnail !== "") {
      classNames += "photo ";
    }

    if (item.read_flag == "0") {
      classNames += "unlead ";
    }

    return classNames;
  }, []);

  var handleGoNotice = function handleGoNotice() {
    var url = (0, notice_action_1.getBrowserLang)() === 'ko_KR' ? "".concat(config_1.SOTONG_DOMAIN, "/?board_type=servicenotice&work=list") : config_1.G_HELP_DOMAIN;
    window.open(url, "_blank");
    return;
  };

  return (0, preact_1.h)(preact_1.Fragment, null, (0, preact_1.h)("div", {
    className: "feedHeaderTab"
  }, (0, preact_1.h)("div", {
    className: "tabItem ".concat(props.step === 'COMPONENT_LIST' || props.step === 'COMPONENT_SETTING' ? 'on' : '', " ").concat(props.badge ? 'new' : '')
  }, (0, preact_1.h)("h2", null, (0, preact_1.h)("button", {
    type: "button",
    onClick: handleStepChange("COMPONENT_LIST")
  }, (0, preact_1.h)("span", null, "\uC54C\uB9BC"))), (0, preact_1.h)("button", {
    className: "btn_admin",
    onClick: handleBtnGoSetting(),
    style: props.userId === "" ? 'none' : 'block'
  })), (0, preact_1.h)("div", {
    className: "tabItem ".concat(props.step === 'COMPONENT_NOTICE' ? 'on' : '')
  }, (0, preact_1.h)("h2", null, (0, preact_1.h)("button", {
    type: "button",
    onClick: handleStepChange("COMPONENT_NOTICE")
  }, (0, preact_1.h)("span", null, "\uC548\uB0B4"))), (0, preact_1.h)("button", {
    className: "btn_more",
    onClick: handleGoNotice
  }, "\uB354\uBCF4\uAE30"))), props.userId === "" && props.step === 'COMPONENT_LIST' && (0, preact_1.h)(Login_1.default, null), props.userId !== "" && (0, preact_1.h)("div", {
    id: "feedList",
    style: props.style
  }, items.length > 0 && (0, preact_1.h)("div", {
    className: "feed_btn"
  }, (0, preact_1.h)("div", {
    className: "inner_bx"
  }, (0, preact_1.h)("span", {
    className: "btn_l"
  }, (0, preact_1.h)("a", {
    href: "",
    className: "all",
    onClick: handleNotificationReadAll
  }, (0, preact_1.h)("a", null, "\uBAA8\uB450 \uC77D\uC74C"))), (0, preact_1.h)("span", {
    className: "btn_r"
  }, (0, preact_1.h)("a", {
    href: "",
    onClick: handleNotificationReadDelete
  }, "\uC77D\uC740 \uC54C\uB9BC \uC0AD\uC81C"), (0, preact_1.h)("em", null, "\xB7"), (0, preact_1.h)("a", {
    href: "",
    onClick: handleNotificationDeleteAll
  }, "\uBAA8\uB450 \uC0AD\uC81C")))), (0, preact_1.h)("div", {
    className: "scroll_area list_add"
  }, items.length === 0 && (0, preact_1.h)("div", {
    className: "no_feed"
  }, (0, preact_1.h)("p", null, (0, preact_1.h)("em", null, "\uBC1B\uC740 \uC54C\uB9BC\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."), (0, preact_1.h)("a", {
    className: "btn_admin",
    href: "#",
    onClick: handleBtnGoSetting()
  }, "\uC54C\uB9BC \uC124\uC815"), "\uC5D0\uC11C \uBC1B\uACE0 \uC2F6\uC740 \uC54C\uB9BC\uC744 \uC120\uD0DD\uD558\uC138\uC694.")), items.length > 0 && items[0] && (0, preact_1.h)(preact_1.Fragment, null, (0, preact_1.h)("ul", {
    className: 'feed_list'
  }, items.map(function (item, index) {
    return (0, preact_1.h)("li", {
      key: index,
      className: getItemClass(item)
    }, (0, preact_1.h)(Profile_1.default, {
      id: item.from_id,
      type: item.noti_type
    }), (0, preact_1.h)("a", {
      href: item.rending_url,
      className: "link",
      target: "_top",
      onClick: handleNotificationRanding(item),
      onMouseUp: handleNotificationRandingWheelClick(item)
    }, (0, preact_1.h)("span", {
      className: "txt"
    }, (0, preact_1.h)(Message_1.default, {
      message: item.noti_message,
      nickname: item.from_nickname,
      head: item.head_text,
      type: item.noti_type
    })), (0, preact_1.h)("span", {
      className: "date"
    }, item.noti_date, (0, preact_1.h)(StationName_1.default, {
      type: item.noti_type
    }, item.station_name)), item.thumbnail !== "" && (0, preact_1.h)("span", {
      className: "photo"
    }, (0, preact_1.h)("img", {
      src: item.thumbnail,
      alt: ""
    }))), item.rending_url && (0, preact_1.h)("a", {
      href: item.rending_url,
      onClick: handleNotificationRanding(item),
      className: "new_window",
      target: "_blank"
    }, "\uC0C8 \uCC3D \uC5F4\uAE30"), (0, preact_1.h)("button", {
      className: "btn_delete",
      onClick: handleNotificationDelete(item)
    }, "\uC0AD\uC81C"));
  })), (0, preact_1.h)("div", {
    ref: lastPositionRef
  }), loading && (0, preact_1.h)("div", {
    className: "loading_feed"
  }, "Loading...")))));
}

exports.default = NotificationList;